module.exports = __webpack_public_path__ + "static/media/spanOfControlIcon.bd427f4a.svg";